export default __webpack_public_path__ + "static/media/image_19.c034c09e.jpg";